import { render, staticRenderFns } from "./PriceWithTaxAdd.vue?vue&type=template&id=00a13226&scoped=true&"
import script from "./PriceWithTaxAdd.vue?vue&type=script&lang=js&"
export * from "./PriceWithTaxAdd.vue?vue&type=script&lang=js&"
import style0 from "./PriceWithTaxAdd.vue?vue&type=style&index=0&id=00a13226&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a13226",
  null
  
)

export default component.exports